module.exports = __webpack_public_path__ + "assets/instagram.b0503764.svg";